export default __webpack_public_path__ + "static/media/dragon.50f986be.svg";